// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:05:23

export default {
  "id": "frogtastic-marble-adventure",
  "slug": "frogtastic-marble-adventure",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/09bfded4708f4fbf91f287cf9eff099d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/09bfded4708f4fbf91f287cf9eff099d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Frogtastic Marble Adventure",
      "description": "Get ready to dive into a world of colors and adrenaline with Frogtastic, the puzzle game that will keep you glued to the screen! Jump into the adventure and save your world from the invasion of colorful spheres by combining strategy and lightning-fast reflexes!\n\nEndless fun! Whether you have a few minutes for a quick game or want to dive into long gaming sessions, Frogtastic is perfect for you.\n\nPlay now and experience a puzzle game you won’t forget!",
      "instructions": "Shoot colorful spheres and form groups of at least three spheres of the same color to make them explode.\n\nBe quick: the spheres move along an increasingly winding path, and you can't let them reach the final destination!\n\nCan you stop all the spheres before it's too late?",
      "genres": [
        "Bubble Shooter",
        "Match-3"
      ],
      "tags": [
        "arcade",
        "ball",
        "bubble",
        "matching"
      ]
    },
    "zh-CN": {
      "title": "青蛙奇妙弹珠冒险",
      "description": "准备好沉浸在一个充满色彩和肾上腺素的世界中，体验Frogtastic这款谜题游戏，它将让你目不转睛！跳入冒险，通过结合策略和闪电般的反应速度，拯救你的世界免受彩色球体的入侵！\n\n无限乐趣！无论你只有几分钟时间玩快速游戏，还是想要沉浸在长时间的游戏中，Frogtastic都是你的完美选择。\n\n现在就玩，体验一款你不会忘记的谜题游戏！",
      "instructions": "射击彩色球体，形成至少三个同色球体的组合使其爆炸。\n\n要快：球体沿着越来越曲折的路径移动，你不能让它们到达最终目的地！\n\n你能在大限来临之前阻止所有球体吗？",
      "genres": [
        "泡泡射击",
        "三消匹配"
      ],
      "tags": [
        "街机",
        "球",
        "泡泡",
        "匹配"
      ]
    },
    "zh-TW": {
      "title": "青蛙驚奇彈珠冒險",
      "description": "準備好跳進一個充滿色彩和肾上腺素的世界吧！與Frogtastic，這款讓你緊貼螢幕的益智遊戲一起開啟冒險，拯救你的世界免於彩球入侵的攻擊，透過結合策略和快速反應！\n\n無盡的樂趣！無論你只有幾分鐘的時間玩一場快速遊戲，還是想投入長時間的遊戲會話，Frogtastic都是你最完美的選擇。\n\n現在就開始玩，體驗一個你永遠不會忘記的益智遊戲！",
      "instructions": "射擊彩色的球體，並形成至少三顆同色球體的組合來使其爆炸。\n\n要快：球體沿著越來越迂迴的路径移動，你不能讓它們達到最終目的地！\n\n你能在還來得及之前阻止所有球體嗎？",
      "genres": [
        "泡泡射手",
        "三消遊戲"
      ],
      "tags": [
        "電玩",
        "球",
        "泡泡",
        "配對"
      ]
    },
    "zh-HK": {
      "title": "青蛙驚奇玻璃珠冒險",
      "description": "準備跳進色彩與肾上腺素的世界，玩轉 Frogtastic 這款讓你黏在螢幕上的謎題遊戲！投入冒險，透過結合策略與迅速的反應，拯救你的世界免受多彩球體的入侵！\n\n無限樂趣！不論你只有幾分鐘的時間玩快速遊戲，還是想要沉浸於長時間遊戲，Frogtastic 都是最適合你的選擇。\n\n即刻遊玩，體驗一款你永遠不會忘記的謎題遊戲！",
      "instructions": "射擊彩色的球體，並形成至少三個同色球體的組合來讓它們爆炸。\n\n要快：球體沿著越來越迂迴的路徑移動，你不能讓它們達到最終目的地！\n\n你能在太晚之前阻止所有球體嗎？",
      "genres": [
        "泡泡打擊機",
        "三合一大戰"
      ],
      "tags": [
        "電玩",
        "波珠",
        "泡泡",
        "配對"
      ]
    },
    "ja": {
      "title": "フロガスタス・マーブル・アドベンチャー",
      "description": "Frogtastic、色とアドレナリンの世界に飛び込みましょう！パズルゲームで画面に引き込まれ、戦略と瞬時に反応する反射神経を駆使して、色とりどりの球体の侵略からあなたの世界を守る冒険に飛び込みましょう！\n\n終わりなき楽しみ！数分間の短いゲームでも、長いゲームセッションに没頭しても、Frogtasticはあなたに最適です。\n\n今すぐプレイして、忘れられないパズルゲームを体験してください！",
      "instructions": "色々な球を撃ち、同じ色の少なくとも3つの球を集めて爆破してください。\n\n素早く動作してください：球は次第に複雑な経路を通って動き、最終目的地に達することを許せません！\n\n手遅れになる前にすべての球を止められるでしょうか？",
      "genres": [
        "バブルシューターセミクオーターワイルドシェイクアップ"
      ],
      "tags": [
        "アーケード",
        "ボール",
        "バブル",
        "マッチング"
      ]
    },
    "ko": {
      "title": "개구리마르블어드벤처",
      "description": "Frogtastic, 색과肾上腺素的 세계로 뛰어들 준비하세요! 전략과 빠른 반응을 결합하여 세상을 colorful spheres의 침략으로부터 구원하는 모험에 뛰어들세요! 짧은 시간이라도 게임을 하고 싶다거나 장시간 게임을 하고 싶다면, Frogtastic는 완벽합니다.\n\n지금 플레이하고 잊지 못할 패자 게임을 경험하세요!",
      "instructions": "색상의 구체를 발사하고 동일한 색상의 구체 3개 이상을 형성하여 폭발시키세요.\n\n빨리 하세요: 구체는 점점 더 곡선적인 경로를 따라 움직이며, 최종 목적지에 도달하지 않도록 해야 합니다!\n\n그때가 되지 않도록 모든 구체를 멈출 수 있을까요?",
      "genres": [
        "버블 샷터",
        "매치 3"
      ],
      "tags": [
        "아케이드",
        "볼",
        "버블",
        "매칭"
      ]
    },
    "fr": {
      "title": "Aventure de la Balle de Marbre Extraordinaire",
      "description": "Préparez-vous à plonger dans un monde de couleurs et d'adrénaline avec Frogtastic, le jeu de puzzle qui vous tiendra accroché à l'écran ! Plongez dans l'aventure et sauvez votre monde de l'invasion des sphères colorées en combinant stratégie et réflexes rapides !\n\nDivertissement infini ! Que vous ayez quelques minutes pour un jeu rapide ou que vous souhaitez vous plonger dans des sessions de jeu longues, Frogtastic est parfait pour vous.\n\nJouez maintenant et découvrez un jeu de puzzle que vous ne pourrez pas oublier !",
      "instructions": "Tirez sur des sphères colorées et former des groupes de trois sphères du même couleur pour les faire exploser.\n\nSoyez rapide : les sphères se déplacent le long d'un chemin de plus en plus tortueux, et vous ne pouvez pas les laisser atteindre leur destination finale !\n\nPouvez-vous arrêter toutes les sphères avant qu'il ne soit trop tard ?",
      "genres": [
        "Pistolet à Bulles",
        "Jeu de Correspondance 3 en 1"
      ],
      "tags": [
        "arcade",
        "balle",
        "bulle",
        "correspondance"
      ]
    }
  }
};
